// extracted by mini-css-extract-plugin
module.exports = {"GroupedTimeReports":"GroupedTimeReports_GroupedTimeReports__dTOIQ","Week":"GroupedTimeReports_Week__23mqX"};